import { useCallback } from 'react'
import store, { dispatch } from 'store'
import { checkStorageBeforeUpload } from 'store/features/user/utils'
import { useAlertPopupsContext } from 'context/AlertPopups'
import { calculateTotalFilesSize } from 'utils/media'
import { IMyFilesMediaItem } from 'types/media'

type TGuardedFiles = Array<File | IMyFilesMediaItem>

// Pre-flight gate for any upload that consumes media-library space. Returns
// true when the picked files fit in the user's remaining storage; otherwise it
// opens the shared full-storage popup (the same one the project media, audio,
// timeline drop and AI-image reference uploads show) and returns false — the
// caller MUST abort the upload.
export const useUploadStorageGuard = () => {
  const { setAlertPopupsData } = useAlertPopupsContext()

  return useCallback(
    async (files: TGuardedFiles): Promise<boolean> => {
      const totalFilesSize = calculateTotalFilesSize(files)

      const { canUpload } = await checkStorageBeforeUpload(
        totalFilesSize,
        dispatch,
        store.getState
      )

      if (!canUpload) {
        setAlertPopupsData({
          fullStoragePopup: {
            isOpen: true
          }
        })
        return false
      }

      return true
    },
    [setAlertPopupsData]
  )
}
